import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={26} height={26} rx={6} fill="#352A1F" />
    <path
      d="M13.5 4C8.81314 4 5 7.81308 5 12.5C5 17.1869 8.81308 21 13.5 21C18.1869 21 22 17.1869 22 12.5C22 7.81308 18.1869 4 13.5 4ZM13.5 5.25915C17.5064 5.25915 20.7407 8.49359 20.7407 12.4999C20.7407 16.5062 17.5063 19.7406 13.5 19.7406C9.4937 19.7406 6.25926 16.5062 6.25926 12.4999C6.25926 8.49359 9.4937 5.25915 13.5 5.25915ZM13.5 7.14815C13.1522 7.14815 12.8704 7.43011 12.8704 7.77772V12.4999C12.8704 12.7327 12.9974 12.9321 13.1853 13.041C14.3593 13.719 15.5482 14.406 16.727 15.0872C17.0283 15.2611 17.419 15.1621 17.5926 14.861C17.7665 14.56 17.6576 14.179 17.3566 14.005L14.1296 12.136V7.7777C14.1296 7.42986 13.8476 7.14813 13.5 7.14813L13.5 7.14815Z"
      fill="#BC9B6A"
    />
  </svg>
);
export default SVGComponent;
